import DOMPurify from 'isomorphic-dompurify'

type AllowedTags = 'b' | 'div' | 'em' | 'i' | 'li' | 'ol' | 'span'

const ALLOWED_TAGS: AllowedTags[] = ['b', 'div', 'em', 'i', 'li', 'ol', 'span']

interface FilterType {
  ALLOWED_TAGS: string[]
}

const purifierFactory = (filter: FilterType) => (unfilteredContent: string): string =>
  DOMPurify.sanitize(unfilteredContent, filter)

export const keepTextContent = purifierFactory({ ALLOWED_TAGS: [] })
export const sanitizeHtmlWithFilter = purifierFactory({ ALLOWED_TAGS })
